import { render, staticRenderFns } from "./personRosterDialog.vue?vue&type=template&id=146d8a66&scoped=true"
import script from "./personRosterDialog.vue?vue&type=script&lang=js"
export * from "./personRosterDialog.vue?vue&type=script&lang=js"
import style0 from "./personRosterDialog.vue?vue&type=style&index=0&id=146d8a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d8a66",
  null
  
)

export default component.exports